import { Loader as YandexMetrikaLoader } from '@/app/modules/Metrics/loaders/YandexMetrika';

const service = new YandexMetrikaLoader();

export function install(
    metrikaConfig: Record<string, string | number | boolean>,
    serverType: string
): Promise<void> {
    return service.bootstrap({
        metrikaConfig,
        afterInstall() {
            // Устанавливаем тип сервера stable/pre-stable
            service.send({ version: serverType });
        },
    });
}

/**
 * Отправляем посылку
 *
 * @param send_parameters
 */
export function send(send_parameters: object) {
    if (send_parameters == null) {
        return;
    }

    service.send({ flow: send_parameters });
}

/**
 * Получает clientID из метрики, если метрика еще не инициализирована вернет null
 */
export function getClientID(): string | null {
    return service.getClientID();
}

/**
 * Получает Yandex metrika instance object
 */
export function getMetrikaInstance(): any {
    return service.getMetrikaInstance();
}
